import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { StepProgressGroup } from 'components/shared/StepProgressGroup/StepProgressGroup'

import { getEvaluations } from '../../model'

import styles from './EvaluatorCard.module.scss'

export const EvaluatorCard = ({
  className = undefined,
  email,
  name,
  status,
}) => {
  const evaluations = getEvaluations(status)

  return (
    <Box
      ariaRole="presentation"
      className={styles.card}
      direction="column"
      tagName="article"
    >
      <Box className={styles.header} justify="space-between" tagName="header">
        <address
          className={cx(styles.evaluator, {
            [className ?? '']: Boolean(className),
          })}
        >
          <p className={styles.name}>{name}</p>
          <p className={styles.email}>{email}</p>
        </address>
      </Box>
      <Box className={styles.progress} direction="column" tagName="footer">
        <StepProgressGroup size="small" steps={Object.values(evaluations)} />
        <p className={styles.status}>
          {Object.values(evaluations)[status - 1].name}
        </p>
      </Box>
    </Box>
  )
}
